import { Pagination } from '@/domain/entities/Pagination'

export class FAQData {
  private id: number
  private question: string
  private answer: string
  private isActive: boolean
  private createdAt: string
  private updatedAt: string

  constructor(
    id: number,
    question: string,
    answer: string,
    isActive: boolean,
    createdAt: string,
    updatedAt: string
  ) {
    {
      this.id = id
      this.question = question
      this.answer = answer
      this.isActive = isActive
      this.createdAt = createdAt
      this.updatedAt = updatedAt
    }
  }
}

export class FAQ {
  public success: boolean
  public message: string
  public pagination?: Pagination
  public data?: FAQData[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: FAQData[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}
